exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".crumbs[data-v-d8ea2a50] .el-breadcrumb{line-height:40px;font-size:12px;width:1180px;margin:0 auto}.crumbs[data-v-d8ea2a50] .el-breadcrumb .el-breadcrumb__inner.is-link,.crumbs[data-v-d8ea2a50] .el-breadcrumb .el-breadcrumb__inner a{font-weight:400;color:#262626}.crumbs[data-v-d8ea2a50] .el-breadcrumb .el-breadcrumb__inner.is-link:hover,.crumbs[data-v-d8ea2a50] .el-breadcrumb .el-breadcrumb__inner a:hover{color:#329d15;cursor:pointer}", ""]);

// exports
